module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1200.ad5999c5.svg";